// Heartbeat indicator — maps the Agent status to the bento heart class
// (healthy / await / degraded / off). The animations are CSS keyframes
// in styles/application.css.

const STATUS_TO_HEART = {
  active: "healthy",
  paused: "off",
  disabled: "off",
  // Future statuses driven by autonomy / canary state:
  awaiting_approval: "await",
  degraded: "degraded",
}

export function Heartbeat({ status, pendingApprovals = 0 }) {
  let cls = STATUS_TO_HEART[status] || "healthy"
  if (pendingApprovals > 0 && cls === "healthy") cls = "await"
  return (
    <div className={`cm-heart ${cls}`}>
      <div className="core" />
    </div>
  )
}
